import MainGrid from "../v2/dashboard/components/MainGrid";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";

const Dashboard = ({ permissions, userRole }) => {
  return (
    <ThemeProvider>
      <MainGrid permissions={permissions} userRole={userRole} />
    </ThemeProvider>
  );
};

export default Dashboard;
